import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { MultiSelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/MultiSearcher";
import { StringExtensions } from "../../../../_helpers/extensions";
import { useFormContext } from "react-hook-form";

export function WastesKindMultiSelect({ name, optionSave, required, wasteId, resetOnReadonlyChange, skipFieldsTrack }) {
  const { getValues } = useFormContext();
  const { wastesKinds } = useSelector((x) => x.wastes);
  const wastesKindsEditHelperName = StringExtensions.extractObjectBeforeLastProperty(name);
  const wastesKindsEditHelper = getValues(`${wastesKindsEditHelperName}.wastes`);
  const [items, setItems] = useState(wastesKinds);
  const onSearchChange = async(searchTerm) => {
    const wasteKinds = wastesKinds?.find(x => x.wasteId === wasteId)?.kinds?.filter(x => x.name.toLowerCase().includes(searchTerm.toLowerCase()));
    setItems(wasteKinds ?? []);
  };

  useEffect(() => {
    const wasteKinds = wastesKinds?.find(x => x.wasteId === wasteId)?.kinds;
    setItems(wasteKinds ?? []);
  }, [wastesKinds]);

  return (
    <>
      <MultiSelectSearcher
        name={name}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "wasteKindId", value: "name" }}
        // optionSave={(x) => (optionSave ? optionSave(x) : x.wasteKindId)}
        placeholder="Wybierz gatunki"
        // editHelper={wastesKindsEditHelper}
        required={required}
        resetOnReadonlyChange={resetOnReadonlyChange}
        skipFieldsTrack={skipFieldsTrack}
      />
    </>
  );
}